import * as React from "react";
import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { RangeSlider, RangeSliderProps } from "@progress/kendo-react-inputs";
import { Hint, Error, Label } from "@progress/kendo-react-labels";

const FormRangeSliderField = (props: RangeSliderProps & FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    min = 0,
    max = 100,
    step = 1,
    optional,
    value,
    onChange,
    wrapperClassName,
    wrapperStyle,
    defaultStart = 0,
    defaultEnd,
    ...other
  } = props;

  // Ensure value has valid structure
  const defaultValue = { start: defaultStart, end: defaultEnd || max };
  const initialValue =
    value && typeof value === "object" && value.start !== undefined
      ? value
      : defaultValue;

  const [rangeValue, setRangeValue] = React.useState(initialValue);

  const handleChange = (e: any) => {
    if (!e.value || typeof e.value !== "object") return; // Prevent errors

    const newValue = {
      start: Math.round(e.value.start),
      end: Math.round(e.value.end),
    };

    setRangeValue(newValue);
    onChange?.({ value: newValue });
  };

  return (
    <FieldWrapper className={wrapperClassName} style={wrapperStyle}>
      {label && (
        <Label
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
          optional={optional}
        >
          {label}
        </Label>
      )}

      <div
        style={{
          position: "relative",
          display: "flex",
          width: "100%",
          flexDirection: "column",
          gap: 10,
        }}
      >
        <RangeSlider
          id={id}
          min={min}
          max={max}
          step={step}
          value={rangeValue}
          disabled={disabled}
          style={{ width: "100%", minHeight: 30 }}
          onChange={handleChange}
          {...other}
        />
        <div
          style={{
            border: "1px solid lightgray",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "500",
            whiteSpace: "nowrap",
            padding: "0 10px",
            borderRadius: 4,
          }}
        >
          {`${rangeValue.start} - ${rangeValue.end}`}
        </div>
      </div>

      {hint && !validationMessage && <Hint>{hint}</Hint>}
      {validationMessage && touched && <Error>{validationMessage}</Error>}
    </FieldWrapper>
  );
};

export default FormRangeSliderField;
